/* Lorelia Buch-Gestalter (Fotobuch + Wandkalender) · v2 08.10.2026
   Luca 08.10.: „man soll das Buch individuell gestalten können – da wo die Bilder hin sollen, sollen sie hinkommen,
   man soll alles probieren können“ + größere Formate direkt im Gestalter wählbar.
   Ablauf: Fotos + Format → Umschlag → Seiten frei gestalten → Stil → prüfen → Warenkorb.
   Frei gestalten: Foto antippen = ziehen verschiebt, Ecken ändern die Größe, zwei Finger skalieren;
   „Ausschnitt“ verschiebt/zoomt das Bild im Rahmen. Texte frei setzbar. Hintergrund je Seite. Rückgängig.
   Vorschau = Druck: jedes Foto hat ein eigenes Rechteck r=[x,y,b,h] (Bruchteile der Seite ohne Beschnitt),
   jeder Text {x,y(Mitte),w,g}; druck/lr_buch_druck.py rechnet 1:1 gleich.
   Öffnen: LRBuch.oeffnen(konfig)  (konfig siehe lokal/index.html bzw. sections/lr-buch-start.liquid) */
(function () {
  'use strict';
  var D = document;

  /* ---------- Vorlagen (Bruchteile der Seite, ohne Beschnitt) – nur Startpunkte, danach ist alles frei ---------- */
  var LAYOUTS = {
    voll:  { name: 'Ganzseitig', slots: [[0, 0, 1, 1]] },
    rand:  { name: 'Mit Rand',   slots: [[.08, .07, .84, .72]], text: [.865, .09] },
    zweiN: { name: 'Zwei nebeneinander', slots: [[.07, .12, .415, .62], [.515, .12, .415, .62]], text: [.865, .09] },
    zweiU: { name: 'Zwei untereinander', slots: [[.08, .06, .84, .425], [.08, .515, .84, .425]] },
    drei:  { name: 'Drei', slots: [[.06, .06, .88, .52], [.06, .62, .43, .32], [.51, .62, .43, .32]] },
    vier:  { name: 'Vier', slots: [[.06, .06, .43, .43], [.51, .06, .43, .43], [.06, .51, .43, .43], [.51, .51, .43, .43]] },
    collage: { name: 'Collage', slots: [[.05, .05, .55, .55], [.63, .05, .32, .26], [.63, .34, .32, .26], [.05, .63, .32, .32], [.40, .63, .55, .32]] }
  };
  var BUCH_LAYOUTS = ['voll', 'rand', 'zweiN', 'zweiU', 'drei', 'vier', 'collage'];
  var UMSCHLAG = { slots: [[0, 0, 1, .74]], titel: [.835, .075], unter: [.915, .03] };
  var KAL_TITEL = { slots: [[.06, .06, .88, .72]], titel: [.85, .07], unter: [.925, .028] };
  var KAL_MONAT = { slots: [[.06, .06, .88, .58]], monat: [.705, .06], gitter: [.08, .755, .84, .2] };
  var GRUENDE = {
    weiss:  { name: 'Weiß',  grund: '#FFFFFF', schrift: '#2A2118' },
    creme:  { name: 'Creme', grund: '#F6F1E7', schrift: '#2A2118' },
    sand:   { name: 'Sand',  grund: '#E9DECB', schrift: '#2A2118' },
    salbei: { name: 'Salbei', grund: '#DCE2D5', schrift: '#2A2118' },
    rose:   { name: 'Rosé',  grund: '#F2E1DD', schrift: '#2A2118' },
    nacht:  { name: 'Nachtblau', grund: '#1F2A36', schrift: '#F4EFE6' },
    schwarz:{ name: 'Schwarz', grund: '#1B1916', schrift: '#F4EFE6' }
  };
  var SCHRIFTEN = {
    elegant: { name: 'Elegant', css: '"Cormorant Garamond","LR Cormorant",Georgia,serif' },
    modern:  { name: 'Modern',  css: 'Jost,"LR Jost","Helvetica Neue",Arial,sans-serif' }
  };
  var MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var TAGE = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
  var MIN_B = .08, FANG = .014, TEXT_G = { klein: .026, mittel: .04, gross: .065 };

  /* Ausschnitt: Bild füllt den Platz (cover), Fokus fx/fy (0..1), Zoom z>=1. Ergebnis in Bruchteilen des Platzes. */
  function ausschnitt(slotB, slotH, bildB, bildH, fx, fy, z) {
    var as = slotB / slotH, ai = bildB / bildH, W, H;
    if (ai > as) { H = 1; W = ai / as; } else { W = 1; H = as / ai; }
    W *= z; H *= z;
    var L = .5 - fx * W, T = .5 - fy * H;
    L = Math.min(0, Math.max(1 - W, L)); T = Math.min(0, Math.max(1 - H, T));
    return { W: W, H: H, L: L, T: T, fx: (.5 - L) / W, fy: (.5 - T) / H };
  }
  function monatsTage(jahr, monat) { // Montag = 0
    var erster = new Date(jahr, monat, 1), off = (erster.getDay() + 6) % 7, n = new Date(jahr, monat + 1, 0).getDate();
    return { off: off, n: n, zeilen: Math.ceil((off + n) / 7) };
  }
  function el(tag, attrs, kinder) {
    var e = D.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') e.textContent = attrs[k]; else if (k === 'html') e.innerHTML = attrs[k];
      else if (k.slice(0, 2) === 'on') e.addEventListener(k.slice(2), attrs[k]); else e.setAttribute(k, attrs[k]);
    });
    (kinder || []).forEach(function (c) { if (c != null) e.append(c); });
    return e;
  }
  function kopie(o) { return JSON.parse(JSON.stringify(o)); }
  function begr(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function neuSlot(r, foto) { return { r: r.slice(), foto: foto || null, fx: .5, fy: .5, z: 1 }; }
  function neuText(rolle, y, g, t) { return { rolle: rolle || null, t: t || '', x: .08, y: y, w: .84, g: g }; }
  var ICON = {
    zu: '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    links: '<svg width="18" height="18" viewBox="0 0 18 18"><path d="M11 4L6 9l5 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    rechts: '<svg width="18" height="18" viewBox="0 0 18 18"><path d="M7 4l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    zurueck: '<svg width="20" height="20" viewBox="0 0 20 20"><path d="M12 5l-5 5 5 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    foto: '<svg width="22" height="22" viewBox="0 0 22 22"><rect x="2.5" y="4.5" width="17" height="13" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="8" cy="9.5" r="1.8" fill="currentColor"/><path d="M3 16l5-4.5 3.5 3 3-2.5L19 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>',
    undo: '<svg width="18" height="18" viewBox="0 0 18 18"><path d="M6 4L2.5 7.5 6 11M3 7.5h7.5a4.5 4.5 0 010 9H8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };
  function layoutIcon(key) {
    var s = '<svg viewBox="0 0 26 26"><rect x=".5" y=".5" width="25" height="25" rx="2" fill="#fff" stroke="#C9BDA8"/>';
    LAYOUTS[key].slots.forEach(function (r) { s += '<rect x="' + (1 + r[0] * 24) + '" y="' + (1 + r[1] * 24) + '" width="' + (r[2] * 24) + '" height="' + (r[3] * 24) + '" fill="#B08C4F" opacity=".55"/>'; });
    return s + '</svg>';
  }

  function Gestalter(K) {
    this.K = K;
    this.kalender = K.art === 'kalender';
    this.format = K.formate.filter(function (f) { return f.key === K.startFormat; })[0] || K.formate[0];
    this.fotos = [];           // {id, name, b, h, mini (URL), druck (Blob), klein}
    this.seiten = [];          // {art:'umschlag'|'innen'|'monat', grund, slots:[{r,foto,fx,fy,z}], texte:[{rolle,t,x,y,w,g}]}
    this.stil = { grund: 'weiss', schrift: 'elegant' };
    this.titel = K.titelVorschlag || 'Unser Jahr';
    this.unter = K.unterVorschlag || '';
    var heute = new Date();
    this.start = { jahr: heute.getMonth() >= 8 ? heute.getFullYear() + 1 : heute.getFullYear(), monat: 0 };
    this.akt = 0;              // aktuelle Seite
    this.sel = null;           // {art:'foto'|'text', j}
    this.ausschnittModus = false;
    this.verlauf = [];         // Rückgängig
    this.bearbeitet = false;   // nach eigener Änderung nie mehr automatisch neu verteilen
    this.schritt = 0;
    this.geprueft = false;
    this.schritte = this.kalender
      ? [{ k: 'fotos', t: 'Fotos' }, { k: 'umschlag', t: 'Titel' }, { k: 'seiten', t: 'Monate' }, { k: 'stil', t: 'Stil' }]
      : [{ k: 'fotos', t: 'Fotos' }, { k: 'umschlag', t: 'Umschlag' }, { k: 'seiten', t: 'Seiten' }, { k: 'stil', t: 'Stil' }];
    this.bauen();
    this.seitenAnlegen();
    this.zeigen();
  }
  var G = Gestalter.prototype;

  G.k = function () { return this.schritte[this.schritt] ? this.schritte[this.schritt].k : 'pruefen'; };
  G.seiteMm = function () { return { b: this.format.b, h: this.format.h }; };
  G.bearbeitbar = function () { var k = this.k(); return k === 'seiten' || k === 'umschlag'; };

  /* ---------- Gerüst ---------- */
  G.bauen = function () {
    var self = this;
    this.wurzel = el('div', { class: 'lb an', role: 'dialog', 'aria-modal': 'true', 'aria-label': this.kalender ? 'Kalender gestalten' : 'Fotobuch gestalten' });
    this.leiste = el('div', { class: 'lb-leiste' });
    this.knZu = el('button', { 'aria-label': 'Gestalter schließen', html: ICON.zu, onclick: function () { self.schliessen(); } });
    this.mitte = el('div', { class: 'lb-mitte' });
    this.leiste.append(this.knZu, this.mitte, el('span'));
    this.bue = el('div', { class: 'lb-bue' });
    this.knUndo = el('button', { class: 'lb-undo', type: 'button', html: ICON.undo + '<span>Rückgängig</span>', onclick: function () { self.rueckgaengig(); } });
    this.zahlEl = el('div', { class: 'lb-seitenzahl' });
    this.halter = el('div', { class: 'lb-halter' });
    this.nav = el('div', { class: 'lb-nav' });
    this.navL = el('button', { 'aria-label': 'Vorige Seite', html: ICON.links, onclick: function () { self.gehe(self.akt - 1); } });
    this.navR = el('button', { 'aria-label': 'Nächste Seite', html: ICON.rechts, onclick: function () { self.gehe(self.akt + 1); } });
    this.navT = el('span', { 'aria-live': 'polite' });
    this.nav.append(this.navL, this.navT, this.navR);
    this.meldungEl = el('div', { class: 'lb-meldung', role: 'status' });
    this.bue.append(this.knUndo, this.zahlEl, this.halter, this.nav, this.meldungEl);
    this.blatt = el('div', { class: 'lb-blatt' });
    this.inhalt = el('div', { class: 'lb-inhalt' });
    this.fuss = el('div', { class: 'lb-fuss' });
    this.knZurueck = el('button', { class: 'lb-zurueck', 'aria-label': 'Zurück', html: ICON.zurueck, onclick: function () { self.zuSchritt(self.schritt - 1); } });
    this.preisEl = el('div', { class: 'lb-preis' });
    this.knWeiter = el('button', { class: 'lb-weiter', onclick: function () { self.weiter(); } });
    this.fuss.append(this.knZurueck, this.preisEl, this.knWeiter);
    this.blatt.append(el('div', { class: 'lb-griff' }), this.inhalt, this.fuss);
    this.wurzel.append(this.leiste, this.bue, this.blatt);
    this.datei = el('input', { type: 'file', accept: 'image/*', multiple: '', hidden: '' });
    this.datei.addEventListener('change', function () { self.fotosLesen(self.datei.files); self.datei.value = ''; });
    this.wurzel.appendChild(this.datei);
    D.body.appendChild(this.wurzel);
    D.documentElement.classList.add('lb-offen');
    this.tasten = function (e) {
      var tag = ((e.target || {}).tagName || '').toLowerCase();
      if (e.key === 'Escape') { if (self.wahlDlg) self.wahlZu(); else if (self.sel) self.auswahl(null); else self.schliessen(); return; }
      if (/input|textarea/.test(tag)) return;
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'z') { e.preventDefault(); self.rueckgaengig(); return; }
      if (self.sel && (e.key === 'Delete' || e.key === 'Backspace') && self.bearbeitbar()) { e.preventDefault(); self.auswahlLoeschen(); return; }
      if (self.k() === 'seiten' && !self.sel) {
        if (e.key === 'ArrowLeft') self.gehe(self.akt - 1); if (e.key === 'ArrowRight') self.gehe(self.akt + 1);
      }
    };
    D.addEventListener('keydown', this.tasten);
    this.vorAbschied = function (e) { if (self.fotos.length && !self.abgegeben) { e.preventDefault(); e.returnValue = ''; } };
    window.addEventListener('beforeunload', this.vorAbschied);
    // Wischen auf freier Fläche = blättern (nur ohne Auswahl, nicht auf Fotos/Texten)
    var sx = null;
    this.halter.addEventListener('touchstart', function (e) {
      var aufElement = e.target.closest && e.target.closest('[data-j],[data-t],.lb-rahmen');
      sx = (!self.sel && !aufElement && e.touches.length === 1) ? e.touches[0].clientX : null;
    }, { passive: true });
    this.halter.addEventListener('touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) self.gehe(self.akt + (dx < 0 ? 1 : -1)); sx = null; });
  };

  G.schliessen = function () {
    if (this.fotos.length && !this.abgegeben && !window.confirm('Gestalter schließen? Deine Fotos und Seiten gehen verloren.')) return;
    window.removeEventListener('beforeunload', this.vorAbschied);
    D.removeEventListener('keydown', this.tasten);
    this.wurzel.remove(); D.documentElement.classList.remove('lb-offen');
    this.fotos.forEach(function (f) { URL.revokeObjectURL(f.mini); });
  };

  G.meldung = function (t) {
    var m = this.meldungEl; m.textContent = t; m.classList.add('an');
    clearTimeout(this._mt); this._mt = setTimeout(function () { m.classList.remove('an'); }, 2800);
  };

  /* ---------- Rückgängig ---------- */
  G.merken = function () {
    this.verlauf.push({ seiten: kopie(this.seiten), titel: this.titel, unter: this.unter, akt: this.akt });
    if (this.verlauf.length > 60) this.verlauf.shift();
    this.bearbeitet = true;
    this.knUndo.disabled = false;
  };
  G.rueckgaengig = function () {
    var v = this.verlauf.pop(); if (!v) { this.meldung('Nichts mehr rückgängig zu machen.'); return; }
    this.seiten = v.seiten; this.titel = v.titel; this.unter = v.unter; this.akt = Math.min(v.akt, this.seiten.length - 1);
    if (this.k() === 'seiten' && this.akt === 0) this.akt = 1;
    this.sel = null; this.ausschnittModus = false; this.zeigen();
  };

  /* ---------- Seiten anlegen / Fotos verteilen ---------- */
  G.innenZiel = function () { // empfohlene Zahl Innenseiten
    var f = this.format, n = this.fotos.length, schritt = f.schritt || 2;
    var s = Math.max(f.seitenMin, Math.ceil(n / 1.5 / schritt) * schritt);
    return Math.min(f.seitenMax, s);
  };
  G.umschlagSeite = function (foto) {
    var g = this.kalender ? KAL_TITEL : UMSCHLAG;
    return { art: 'umschlag', grund: null, slots: [neuSlot(g.slots[0], foto)],
      texte: [neuText('titel', g.titel[0], this.kalender ? .068 : .072), neuText('unter', g.unter[0], .03)] };
  };
  G.leereSeite = function () { return { art: 'innen', layout: 'rand', grund: null, slots: [neuSlot(LAYOUTS.rand.slots[0])], texte: [] }; };
  G.seitenAnlegen = function () {
    this.seiten = [this.umschlagSeite(null)];
    if (this.kalender) { for (var m = 0; m < 12; m++) this.seiten.push({ art: 'monat', grund: null, slots: [neuSlot(KAL_MONAT.slots[0])], texte: [] }); }
    else for (var i = 0; i < this.format.seitenMin; i++) this.seiten.push(this.leereSeite());
  };
  G.verteilen = function () { // alles neu automatisch verteilen (Umschlag-Gestaltung bleibt)
    var F = this.fotos, self = this;
    if (this.kalender) {
      this.seiten.forEach(function (s, i) { if (s.slots[0]) { s.slots[0].foto = i < F.length ? F[i].id : (F.length >= 13 ? F[i % F.length].id : null); s.slots[0].fx = .5; s.slots[0].fy = .5; s.slots[0].z = 1; } });
      return;
    }
    var um = this.seiten[0] || this.umschlagSeite(null);
    var umschlagFoto = um.slots[0] && um.slots[0].foto;
    if ((!umschlagFoto || !this.foto(umschlagFoto)) && F.length) { umschlagFoto = F[0].id; if (um.slots[0]) um.slots[0].foto = umschlagFoto; }
    var rest = F.length > 1 ? F.filter(function (f) { return f.id !== umschlagFoto; }) : F.slice();
    var P = this.innenZiel(), n = rest.length;
    var seiten = [um];
    var basis = Math.floor(n / P), plus = n % P, k = 0;
    for (var i = 0; i < P; i++) {
      var c = Math.min(4, basis + (i < plus ? 1 : 0));
      var teil = rest.slice(k, k + c); k += c;
      var layout;
      if (c <= 1) layout = (teil[0] && teil[0].b > teil[0].h * 1.15) ? 'voll' : 'rand';
      else if (c === 2) layout = (teil[0].h > teil[0].b && teil[1].h > teil[1].b) ? 'zweiN' : 'zweiU';
      else if (c === 3) layout = 'drei'; else layout = 'vier';
      seiten.push({ art: 'innen', layout: layout, grund: null, texte: [], slots: LAYOUTS[layout].slots.map(function (r, j) { return neuSlot(r, teil[j] ? teil[j].id : null); }) });
    }
    while (k < n) seiten.push({ art: 'innen', layout: 'rand', grund: null, texte: [], slots: [neuSlot(LAYOUTS.rand.slots[0], rest[k++].id)] });
    var schritt = this.format.schritt || 2;
    while ((seiten.length - 1) % schritt) seiten.push(this.leereSeite());
    this.seiten = seiten; this.akt = Math.min(this.akt, seiten.length - 1);
    if (seiten.length - 1 > this.format.seitenMax) self.meldung('Sehr viele Fotos – maximal ' + this.format.seitenMax + ' Seiten.');
  };

  /* ---------- Fotos lesen (verkleinert für Vorschau und Druck, Hochkant-Fotos richtig gedreht) ---------- */
  G.fotosLesen = function (liste) {
    var self = this, dateien = [].slice.call(liste || []).filter(function (f) { return /^image\//.test(f.type) || /\.(jpe?g|png|heic|heif|webp)$/i.test(f.name); });
    if (!dateien.length) return;
    var vorher = this.fotos.length, fertig = 0;
    this.laedt = dateien.length; this.zeigen();
    var kette = Promise.resolve();
    dateien.forEach(function (datei) {
      kette = kette.then(function () { return self.einFoto(datei); }).then(function (f) {
        if (f) self.fotos.push(f);
      }, function () { self.meldung('„' + datei.name + '“ konnte nicht gelesen werden.'); }).then(function () {
        fertig++; self.laedt = dateien.length - fertig; if (self.k() === 'fotos') self.inhaltFotos();
      });
    });
    kette.then(function () {
      self.laedt = 0;
      if (self.fotos.length !== vorher) {
        if (!self.bearbeitet) self.verteilen();
        else self.meldung((self.fotos.length - vorher) + ' neue Fotos liegen unten bereit – antippen legt sie auf die Seite.');
      }
      self.zeigen();
    });
  };
  G.einFoto = function (datei) {
    var MAX = 4200; // reicht für 28×28 cm und A3 bei ~300 dpi
    return bildLaden(datei).then(function (img) {
      var b = img.width, h = img.height;
      var s = Math.min(1, MAX / Math.max(b, h)), cb = Math.round(b * s), ch = Math.round(h * s);
      var c = D.createElement('canvas'); c.width = cb; c.height = ch; c.getContext('2d').drawImage(img, 0, 0, cb, ch);
      var m = D.createElement('canvas'), ms = Math.min(1, 900 / Math.max(b, h)); m.width = Math.round(b * ms); m.height = Math.round(h * ms);
      m.getContext('2d').drawImage(img, 0, 0, m.width, m.height);
      if (img.close) img.close();
      return Promise.all([alsBlob(c, .9), alsBlob(m, .82)]).then(function (bl) {
        return { id: 'f' + Math.random().toString(36).slice(2, 9), name: datei.name, b: b, h: h, druck: bl[0], mini: URL.createObjectURL(bl[1]), klein: Math.max(b, h) < 1400 };
      });
    });
  };
  function bildLaden(datei) {
    if (window.createImageBitmap) return createImageBitmap(datei, { imageOrientation: 'from-image' }).catch(function () { return imgLaden(datei); });
    return imgLaden(datei);
  }
  function imgLaden(datei) {
    return new Promise(function (ok, fehler) { var u = URL.createObjectURL(datei), i = new Image(); i.onload = function () { ok(i); }; i.onerror = fehler; i.src = u; });
  }
  function alsBlob(c, q) { return new Promise(function (ok) { c.toBlob(ok, 'image/jpeg', q); }); }
  G.foto = function (id) { for (var i = 0; i < this.fotos.length; i++) if (this.fotos[i].id === id) return this.fotos[i]; return null; };
  G.nutzung = function (id) { var n = 0; this.seiten.forEach(function (s) { s.slots.forEach(function (x) { if (x.foto === id) n++; }); }); return n; };

  /* ---------- Seite zeichnen ---------- */
  G.grundVon = function (seite) { return GRUENDE[seite.grund] || GRUENDE[this.stil.grund]; };
  G.textInhalt = function (t) { return t.rolle === 'titel' ? this.titel : t.rolle === 'unter' ? this.unter : t.t; };
  G.slotStil = function (d, img, slot, mm) {
    var r = slot.r;
    d.style.left = r[0] * 100 + '%'; d.style.top = r[1] * 100 + '%'; d.style.width = r[2] * 100 + '%'; d.style.height = r[3] * 100 + '%';
    var f = slot.foto && this.foto(slot.foto);
    if (f && img) {
      var a = ausschnitt(r[2] * mm.b, r[3] * mm.h, f.b, f.h, slot.fx, slot.fy, slot.z);
      slot.fx = a.fx; slot.fy = a.fy;
      img.style.width = a.W * 100 + '%'; img.style.height = a.H * 100 + '%'; img.style.left = a.L * 100 + '%'; img.style.top = a.T * 100 + '%';
    }
  };
  G.textStil = function (d, t) {
    d.style.left = t.x * 100 + '%'; d.style.width = t.w * 100 + '%'; d.style.top = t.y * 100 + '%';
    d.style.fontSize = t.g * 100 + 'cqw';
  };
  G.seiteBauen = function (idx, breitePx, bearbeiten) {
    var self = this, seite = this.seiten[idx], mm = this.seiteMm(), G2 = this.grundVon(seite);
    var hoehePx = breitePx * mm.h / mm.b;
    var s = el('div', { class: 'lb-seite' + (bearbeiten ? ' bearbeiten' : '') });
    s.style.width = breitePx + 'px'; s.style.height = hoehePx + 'px';
    s.style.setProperty('--grund', G2.grund); s.style.setProperty('--schrift', G2.schrift);
    s.style.setProperty('--seitenschrift', SCHRIFTEN[this.stil.schrift].css);
    s.style.setProperty('--leer', G2.schrift === '#2A2118' ? 'rgba(42,33,24,.09)' : 'rgba(255,255,255,.12)');
    if (!this.kalender && seite.art === 'innen') s.classList.add('buch', idx % 2 ? 'rechts' : 'links');
    if (this.kalender) s.appendChild(el('div', { class: 'lb-ring' }));
    var sel = bearbeiten ? this.sel : null;
    seite.slots.forEach(function (slot, j) {
      var d = el('div', { class: 'lb-slot', 'data-j': String(j) }), img = null;
      var f = slot.foto && self.foto(slot.foto);
      if (f) { img = el('img', { src: f.mini, alt: '', draggable: 'false' }); d.appendChild(img); }
      else d.classList.add('leer');
      self.slotStil(d, img, slot, mm);
      if (sel && sel.art === 'foto' && sel.j === j) d.classList.add('gewaehlt');
      s.appendChild(d);
    });
    if (seite.art === 'monat') {
      var geo = KAL_MONAT;
      var m = (this.start.monat + idx - 1), jahr = this.start.jahr + Math.floor(m / 12); m = m % 12;
      var mo = el('div', { class: 'lb-monat', text: MONATE[m] + ' ' + jahr });
      mo.style.top = (geo.monat[0] - geo.monat[1] / 2) * 100 + '%'; mo.style.fontSize = geo.monat[1] * 100 + 'cqw';
      s.appendChild(mo);
      var t = monatsTage(jahr, m), g = el('div', { class: 'lb-kal' }), gr = geo.gitter;
      g.style.left = gr[0] * 100 + '%'; g.style.top = gr[1] * 100 + '%'; g.style.width = gr[2] * 100 + '%'; g.style.height = gr[3] * 100 + '%';
      g.style.gridTemplateRows = 'repeat(' + (t.zeilen + 1) + ',1fr)';
      TAGE.forEach(function (x) { g.appendChild(el('span', { class: 'kopf', text: x.toUpperCase() })); });
      for (var z = 0; z < t.zeilen * 7; z++) {
        var tag = z - t.off + 1, sp = el('span', { text: tag >= 1 && tag <= t.n ? String(tag) : '' });
        if (tag < 1 || tag > t.n) sp.className = 'aus'; else if (z % 7 === 6) sp.className = 'so';
        g.appendChild(sp);
      }
      s.appendChild(g);
    }
    (seite.texte || []).forEach(function (tx, j) {
      var inhalt = self.textInhalt(tx);
      if (!inhalt && !bearbeiten) return;
      var platzhalter = tx.rolle === 'titel' ? 'Euer Titel' : tx.rolle === 'unter' ? 'Untertitel (optional)' : 'Dein Text';
      var d = el('div', { class: 'lb-text' + (inhalt ? '' : ' leer'), 'data-t': String(j) }, [el('span', { text: inhalt || platzhalter })]);
      self.textStil(d, tx);
      if (sel && sel.art === 'text' && sel.j === j) {
        d.classList.add('gewaehlt');
        d.append(el('i', { class: 'lb-griff-p w', 'data-griff': 'w' }), el('i', { class: 'lb-griff-p e', 'data-griff': 'e' }));
      }
      s.appendChild(d);
    });
    // Rahmen mit Ecken über dem gewählten Foto (liegt über allem, damit die Ecken immer greifbar sind)
    if (sel && sel.art === 'foto' && seite.slots[sel.j]) {
      var rr = el('div', { class: 'lb-rahmen' + (this.ausschnittModus ? ' ausschnitt' : '') });
      ['nw', 'ne', 'sw', 'se'].forEach(function (c) { rr.appendChild(el('i', { class: 'lb-griff-p ' + c, 'data-griff': c })); });
      rr.appendChild(el('b', { class: 'lb-tipp', text: this.ausschnittModus ? 'Bild im Rahmen verschieben · zwei Finger zoomen' : 'Ziehen · Ecken = Größe' }));
      var r = seite.slots[sel.j].r;
      rr.style.left = r[0] * 100 + '%'; rr.style.top = r[1] * 100 + '%'; rr.style.width = r[2] * 100 + '%'; rr.style.height = r[3] * 100 + '%';
      s.appendChild(rr);
    }
    s.appendChild(el('div', { class: 'lb-hilfe x', hidden: '' }));
    s.appendChild(el('div', { class: 'lb-hilfe y', hidden: '' }));
    if (bearbeiten) this.seiteGriffe(s, idx);
    return s;
  };

  /* ---------- Frei gestalten: ziehen, Ecken, zwei Finger, Ausschnitt ---------- */
  G.fangLinien = function (seite, ausser) {
    var xs = [0, .5, 1], ys = [0, .5, 1];
    seite.slots.forEach(function (sl, j) { if (ausser && ausser.art === 'foto' && ausser.j === j) return; var r = sl.r; xs.push(r[0], r[0] + r[2] / 2, r[0] + r[2]); ys.push(r[1], r[1] + r[3] / 2, r[1] + r[3]); });
    return { x: xs, y: ys };
  };
  function fangen(kanten, linien) { // kanten: Werte des bewegten Elements, liefert Verschiebung + Linie
    var best = null;
    kanten.forEach(function (k) { linien.forEach(function (l) { var d = l - k; if (Math.abs(d) < FANG && (!best || Math.abs(d) < Math.abs(best.d))) best = { d: d, l: l }; }); });
    return best;
  }
  G.seiteGriffe = function (s, idx) {
    var self = this, mm = this.seiteMm(), seite = this.seiten[idx];
    var punkte = {}, z = null; // z = laufende Geste
    var hx = s.querySelector('.lb-hilfe.x'), hy = s.querySelector('.lb-hilfe.y');
    function liste() { return Object.keys(punkte).map(function (k) { return punkte[k]; }); }
    function abstand() { var p = liste(); return p.length > 1 ? Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) : 0; }
    function mitte() { var p = liste(), x = 0, y = 0; p.forEach(function (q) { x += q.x; y += q.y; }); return p.length ? { x: x / p.length, y: y / p.length } : { x: 0, y: 0 }; }
    function hilfe(fx, fy) {
      if (fx) { hx.hidden = false; hx.style.left = fx.l * 100 + '%'; } else hx.hidden = true;
      if (fy) { hy.hidden = false; hy.style.top = fy.l * 100 + '%'; } else hy.hidden = true;
    }
    function elementVon(t) {
      var g = t.closest('[data-griff]'); if (g) return { griff: g.getAttribute('data-griff') };
      if (t.closest('.lb-rahmen') && self.sel && self.sel.art === 'foto') return { art: 'foto', j: self.sel.j };
      var tx = t.closest('[data-t]'); if (tx) return { art: 'text', j: +tx.getAttribute('data-t') };
      var sl = t.closest('[data-j]'); if (sl) return { art: 'foto', j: +sl.getAttribute('data-j') };
      return null;
    }
    function neuStart(art) {
      var sel = self.sel, box = s.getBoundingClientRect();
      z = { art: art, box: box, mitte: mitte(), abst: abstand(), bewegt: z ? z.bewegt : false, gemerkt: z ? z.gemerkt : false, neuGewaehlt: z ? z.neuGewaehlt : false, griff: z ? z.griff : null };
      if (!sel) return;
      if (sel.art === 'foto') { var sl = seite.slots[sel.j]; z.r = sl.r.slice(); z.fx = sl.fx; z.fy = sl.fy; z.zoom = sl.z; }
      else { var t = seite.texte[sel.j]; z.t = { x: t.x, y: t.y, w: t.w, g: t.g }; }
    }
    function aendernBeginnen() { if (!z.gemerkt) { z.gemerkt = true; var v = self.seiten; self.seiten = kopie(v); self.merken(); self.seiten = v; } }
    function zeichnen() {
      var sel = self.sel; if (!sel) return;
      if (sel.art === 'foto') {
        var sl = seite.slots[sel.j], d = s.querySelector('[data-j="' + sel.j + '"]'), rr = s.querySelector('.lb-rahmen');
        if (d) self.slotStil(d, d.querySelector('img'), sl, mm);
        if (rr) { var r = sl.r; rr.style.left = r[0] * 100 + '%'; rr.style.top = r[1] * 100 + '%'; rr.style.width = r[2] * 100 + '%'; rr.style.height = r[3] * 100 + '%'; }
      } else { var d2 = s.querySelector('[data-t="' + sel.j + '"]'); if (d2) self.textStil(d2, seite.texte[sel.j]); }
    }
    s.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      var treffer = elementVon(e.target);
      try { s.setPointerCapture(e.pointerId); } catch (x) {}
      punkte[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (liste().length === 1) {
        z = null;
        if (treffer && treffer.griff) { neuStart('griff'); z.griff = treffer.griff; return; }
        if (treffer && treffer.art) {
          var gleich = self.sel && self.sel.art === treffer.art && self.sel.j === treffer.j;
          if (!gleich) { self.sel = { art: treffer.art, j: treffer.j }; self.ausschnittModus = false; }
          neuStart(self.ausschnittModus && treffer.art === 'foto' ? 'ausschnitt' : 'schieben'); z.neuGewaehlt = !gleich;
          return;
        }
        neuStart('leer');
      } else if (z && z.art !== 'leer') neuStart(z.art === 'griff' ? 'schieben' : z.art);
      e.preventDefault();
    });
    s.addEventListener('pointermove', function (e) {
      if (!punkte[e.pointerId] || !z) return;
      punkte[e.pointerId] = { x: e.clientX, y: e.clientY };
      var m = mitte(), dxp = m.x - z.mitte.x, dyp = m.y - z.mitte.y;
      if (!z.bewegt && Math.abs(dxp) + Math.abs(dyp) < 5 && liste().length < 2) return;
      if (z.art === 'leer' || !self.sel) return;
      z.bewegt = true; aendernBeginnen();
      var dx = dxp / z.box.width, dy = dyp / z.box.height, k = (liste().length > 1 && z.abst) ? abstand() / z.abst : 1;
      var sel = self.sel, L = self.fangLinien(seite, sel), fx = null, fy = null;
      if (sel.art === 'foto') {
        var sl = seite.slots[sel.j], f = self.foto(sl.foto);
        if (z.art === 'ausschnitt' && f) {
          var a = ausschnitt(z.r[2] * mm.b, z.r[3] * mm.h, f.b, f.h, z.fx, z.fy, z.zoom), rpx = z.r[2] * z.box.width, rpy = z.r[3] * z.box.height;
          sl.z = begr(z.zoom * k, 1, 5);
          var a2 = ausschnitt(z.r[2] * mm.b, z.r[3] * mm.h, f.b, f.h, z.fx - dxp / (a.W * rpx), z.fy - dyp / (a.H * rpy), sl.z);
          sl.fx = a2.fx; sl.fy = a2.fy;
        } else if (z.art === 'griff') {
          var r = z.r.slice(), c = z.griff, x0 = r[0], y0 = r[1], x1 = r[0] + r[2], y1 = r[1] + r[3];
          if (c.indexOf('w') >= 0) x0 = Math.min(x1 - MIN_B, x0 + dx); else x1 = Math.max(x0 + MIN_B, x1 + dx);
          if (c.indexOf('n') >= 0) y0 = Math.min(y1 - MIN_B, y0 + dy); else y1 = Math.max(y0 + MIN_B, y1 + dy);
          fx = fangen([c.indexOf('w') >= 0 ? x0 : x1], L.x); fy = fangen([c.indexOf('n') >= 0 ? y0 : y1], L.y);
          if (fx) { if (c.indexOf('w') >= 0) x0 += fx.d; else x1 += fx.d; }
          if (fy) { if (c.indexOf('n') >= 0) y0 += fy.d; else y1 += fy.d; }
          sl.r = [x0, y0, x1 - x0, y1 - y0];
        } else {
          var nb = begr(z.r[2] * k, MIN_B, 1.6), nh = begr(z.r[3] * k, MIN_B, 1.6);
          var nx = z.r[0] + z.r[2] / 2 - nb / 2 + dx, ny = z.r[1] + z.r[3] / 2 - nh / 2 + dy;
          if (k === 1) { fx = fangen([nx, nx + nb / 2, nx + nb], L.x); fy = fangen([ny, ny + nh / 2, ny + nh], L.y); if (fx) nx += fx.d; if (fy) ny += fy.d; }
          sl.r = [begr(nx, -nb + .05, .95), begr(ny, -nh + .05, .95), nb, nh];
        }
      } else {
        var t = seite.texte[sel.j];
        if (z.art === 'griff') {
          var tx0 = z.t.x, tx1 = z.t.x + z.t.w;
          if (z.griff === 'w') tx0 = Math.min(tx1 - .12, tx0 + dx); else tx1 = Math.max(tx0 + .12, tx1 + dx);
          t.x = tx0; t.w = tx1 - tx0;
        } else {
          t.g = begr(z.t.g * k, .012, .2);
          var px = z.t.x + dx, py = z.t.y + dy;
          if (k === 1) { fx = fangen([px + z.t.w / 2], [.5]); fy = fangen([py], [.5]); if (fx) px += fx.d; if (fy) py += fy.d; }
          t.x = begr(px, -t.w + .1, .9); t.y = begr(py, .02, .98);
        }
      }
      hilfe(fx, fy); zeichnen();
    });
    function ende(e) {
      if (!punkte[e.pointerId]) return;
      delete punkte[e.pointerId];
      if (liste().length) { neuStart(z ? (z.art === 'griff' ? 'schieben' : z.art) : 'leer'); return; }
      hilfe(null, null);
      var war = z; z = null; if (!war) return;
      if (war.art === 'leer') { if (!war.bewegt && self.sel) self.auswahl(null); return; }
      if (!war.bewegt && !war.neuGewaehlt && self.sel && self.sel.art === 'foto' && !seite.slots[self.sel.j].foto) { self.wahlAuf(idx, self.sel.j); return; }
      self.nachAenderung(war.neuGewaehlt || !war.bewegt);
    }
    s.addEventListener('pointerup', ende); s.addEventListener('pointercancel', ende);
    s.addEventListener('dblclick', function (e) { var t = elementVon(e.target); if (t && t.art === 'foto' && seite.slots[t.j].foto) { self.sel = { art: 'foto', j: t.j }; self.ausschnittModus = !self.ausschnittModus; self.nachAenderung(true); } });
    s.addEventListener('wheel', function (e) {
      var sel = self.sel; if (!sel) return; e.preventDefault();
      var v = self.seiten; self.seiten = kopie(v); if (!self._radZeit || Date.now() - self._radZeit > 800) self.merken(); self.seiten = v; self._radZeit = Date.now();
      var k = e.deltaY < 0 ? 1.06 : 1 / 1.06;
      if (sel.art === 'foto') {
        var sl = seite.slots[sel.j];
        if (self.ausschnittModus) sl.z = begr(sl.z * k, 1, 5);
        else { var r = sl.r, nb = begr(r[2] * k, MIN_B, 1.6), nh = begr(r[3] * k, MIN_B, 1.6); sl.r = [r[0] + r[2] / 2 - nb / 2, r[1] + r[3] / 2 - nh / 2, nb, nh]; }
      } else { var t = seite.texte[sel.j]; t.g = begr(t.g * k, .012, .2); }
      self.seiteZeigen();
    }, { passive: false });
  };
  G.nachAenderung = function (blattNeu) {
    if (blattNeu) this.inhaltAktuell(); else { this.seiteZeigen(); this.streifenAuffrischen(); }
  };
  G.inhaltAktuell = function () { var k = this.k(); if (k === 'seiten') this.inhaltSeiten(); else if (k === 'umschlag') this.inhaltUmschlag(); else this.seiteZeigen(); };
  G.auswahl = function (sel) { this.sel = sel; this.ausschnittModus = false; this.inhaltAktuell(); };
  G.aktSeite = function () { return this.seiten[this.k() === 'umschlag' ? 0 : this.akt]; };
  G.auswahlLoeschen = function () {
    var sel = this.sel, seite = this.aktSeite(); if (!sel) return;
    if (sel.art === 'text' && seite.texte[sel.j].rolle === 'titel') { this.meldung('Der Titel bleibt – du kannst ihn verschieben oder verkleinern.'); return; }
    this.merken();
    if (sel.art === 'foto') seite.slots.splice(sel.j, 1); else seite.texte.splice(sel.j, 1);
    this.sel = null; this.ausschnittModus = false; this.inhaltAktuell();
  };

  /* Foto auf die aktuelle Seite legen (aus der Fotoleiste): ersetzt das gewählte Foto oder kommt als neuer Rahmen dazu */
  G.fotoAufSeite = function (f) {
    var seite = this.aktSeite(), mm = this.seiteMm(), sel = this.sel;
    this.merken();
    if (sel && sel.art === 'foto' && seite.slots[sel.j]) { var sl = seite.slots[sel.j]; sl.foto = f.id; sl.fx = .5; sl.fy = .5; sl.z = 1; this.inhaltAktuell(); return; }
    var leer = seite.slots.map(function (x, j) { return x.foto ? -1 : j; }).filter(function (j) { return j >= 0; })[0];
    if (leer != null) { seite.slots[leer].foto = f.id; this.sel = { art: 'foto', j: leer }; this.inhaltAktuell(); return; }
    var ar = (f.b / f.h) / (mm.b / mm.h), b = .6, h = b / ar;
    if (h > .6) { h = .6; b = h * ar; }
    var n = seite.slots.length, v = (n % 5) * .04;
    seite.slots.push(neuSlot([begr((1 - b) / 2 + v, 0, 1 - b), begr((1 - h) / 2 + v, 0, 1 - h), b, h], f.id));
    this.sel = { art: 'foto', j: seite.slots.length - 1 }; this.ausschnittModus = false;
    this.inhaltAktuell();
  };
  G.textDazu = function () {
    var seite = this.aktSeite(); this.merken();
    var y = seite.texte.length ? Math.min(.92, seite.texte[seite.texte.length - 1].y + .08) : .88;
    seite.texte.push(neuText(null, y, TEXT_G.mittel, ''));
    this.sel = { art: 'text', j: seite.texte.length - 1 }; this.inhaltAktuell();
    var f = this.inhalt.querySelector('.lb-textfeld'); if (f) setTimeout(function () { f.focus(); }, 60);
  };

  G.seiteZeigen = function () {
    var k = this.k(), idx = k === 'umschlag' ? 0 : this.akt;
    var mm = this.seiteMm(), box = this.halter.getBoundingClientRect();
    var bw = Math.max(120, box.width), bh = Math.max(120, box.height);
    var breite = Math.min(bw, bh * mm.b / mm.h);
    this.halter.textContent = '';
    this.halter.appendChild(this.seiteBauen(idx, Math.floor(breite), this.bearbeitbar()));
    var n = this.seiten.length;
    this.navT.textContent = idx === 0 ? (this.kalender ? 'Titelblatt' : 'Umschlag') : (this.kalender ? MONATE[(this.start.monat + idx - 1) % 12] : 'Seite ' + idx + ' von ' + (n - 1));
    this.navL.disabled = idx <= 0; this.navR.disabled = idx >= n - 1;
    this.nav.hidden = k === 'umschlag';
    this.zahlEl.textContent = this.format.label + ' · ' + (this.kalender ? '13 Blätter' : (n - 1) + ' Seiten');
    this.knUndo.hidden = !this.bearbeitbar(); this.knUndo.disabled = !this.verlauf.length;
  };
  G.gehe = function (i) {
    var min = this.k() === 'seiten' ? 1 : 0;
    i = Math.max(min, Math.min(this.seiten.length - 1, i)); if (i === this.akt) return;
    this.akt = i; this.sel = null; this.ausschnittModus = false;
    if (this.k() === 'seiten') this.inhaltSeiten(); else this.seiteZeigen();
  };

  /* ---------- Schritte ---------- */
  G.zuSchritt = function (n) { if (n < 0) return; this.schritt = Math.min(n, this.schritte.length); this.sel = null; this.ausschnittModus = false; if (this.schritt === 2 && this.akt === 0) this.akt = 1; this.zeigen(); };
  G.weiter = function () {
    var p = this.pruefung(this.k());
    if (p) { this.meldung(p); return; }
    if (this.schritt < this.schritte.length) this.zuSchritt(this.schritt + 1);
    else this.abgeben();
  };
  G.pruefung = function (k) {
    if (k === 'fotos') { if (this.laedt) return 'Einen Moment, die Fotos werden noch geladen …'; if (!this.fotos.length) return 'Bitte wähle zuerst deine Fotos.'; }
    if (k === 'umschlag' && !this.titel.trim()) return 'Bitte gib einen Titel ein.';
    if (k === 'pruefen' && !this.geprueft) return 'Bitte bestätige, dass du alles geprüft hast.';
    if (k === 'pruefen' && !this.kalender && (this.seiten.length - 1) % (this.format.schritt || 2)) return 'Die Seitenzahl muss gerade sein.';
    return '';
  };
  G.zeigen = function () {
    var self = this, k = this.k();
    this.mitte.textContent = '';
    this.mitte.appendChild(el('b', { text: k === 'pruefen' ? (this.kalender ? 'Dein Kalender' : 'Dein Fotobuch') : 'Schritt ' + (this.schritt + 1) + ' von ' + this.schritte.length + ' · ' + this.schritte[this.schritt].t }));
    var pk = el('div', { class: 'lb-punkte', 'aria-hidden': 'true' });
    this.schritte.forEach(function (_, i) { var x = el('i'); x.style.setProperty('--f', i < self.schritt ? 1 : (i === self.schritt ? .35 : 0)); pk.appendChild(x); });
    this.mitte.appendChild(pk);
    this.knZurueck.disabled = this.schritt === 0;
    this.preisAuffrischen();
    var naechst = this.schritte[this.schritt + 1];
    this.knWeiter.textContent = k === 'pruefen' ? 'In den Warenkorb' : (naechst ? 'Weiter' : 'Fertig · Prüfen');
    this.knWeiter.setAttribute('aria-disabled', this.pruefung(k) ? 'true' : 'false');
    this.wurzel.classList.toggle('frei', this.bearbeitbar());
    if (k === 'fotos') this.inhaltFotos(); else if (k === 'umschlag') this.inhaltUmschlag(); else if (k === 'seiten') this.inhaltSeiten(); else if (k === 'stil') this.inhaltStil(); else this.inhaltPruefen();
  };
  G.preisAuffrischen = function () {
    this.preisEl.innerHTML = '';
    this.preisEl.append(el('small', { text: this.format.label }), el('b', { text: (this.format.preis || 0).toFixed(2).replace('.', ',') + ' €' }));
  };
  G.frage = function (titel, marke) { var f = el('div', { class: 'lb-frage' }, [el('h2', { text: titel })]); if (marke) f.appendChild(el('em', { text: marke })); return f; };

  /* Format wechseln (Größe + Einband) – Gestaltung bleibt, weil alles in Bruchteilen der Seite gespeichert ist */
  G.formatWahl = function () {
    var self = this, box = el('div');
    var gruppen = {};
    this.K.formate.forEach(function (f) { var g = f.art || ''; (gruppen[g] = gruppen[g] || []).push(f); });
    Object.keys(gruppen).forEach(function (g) {
      if (Object.keys(gruppen).length > 1) box.appendChild(el('span', { class: 'lb-label', text: g }));
      var ch = el('div', { class: 'lb-chips lb-formate' });
      gruppen[g].forEach(function (f) {
        var b = el('button', { class: 'lb-chip lb-fchip', type: 'button', 'aria-pressed': String(f.key === self.format.key) }, [
          el('span', { class: 'lb-fsym', style: 'aspect-ratio:' + f.b + '/' + f.h + ';width:' + Math.round(22 * Math.min(1, f.b / f.h)) + 'px' }),
          el('span', {}, [el('b', { text: f.groesse || f.label }), el('small', { text: (f.preis || 0).toFixed(2).replace('.', ',') + ' €' + (f.hinweis ? ' · ' + f.hinweis : '') })])
        ]);
        if (f.verfuegbar === false) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); }
        b.addEventListener('click', function () { self.formatSetzen(f); });
        ch.appendChild(b);
      });
      box.appendChild(ch);
    });
    return box;
  };
  G.formatSetzen = function (f) {
    if (f.key === this.format.key) return;
    this.format = f;
    if (!this.kalender) { while (this.seiten.length - 1 < f.seitenMin) this.seiten.push(this.leereSeite()); }
    this.zeigen();
  };

  G.inhaltFotos = function () {
    var self = this, I = this.inhalt; I.textContent = '';
    I.appendChild(this.frage(this.kalender ? 'Welche Fotos sollen in deinen Kalender?' : 'Welche Fotos sollen ins Buch?', 'Pflicht'));
    I.appendChild(el('button', { class: 'lb-hoch', html: ICON.foto + '<span>' + (this.fotos.length ? 'Weitere Fotos hinzufügen' : 'Fotos auswählen') + '</span>', onclick: function () { self.datei.click(); } }));
    if (this.laedt) I.appendChild(el('p', { class: 'lb-laedt', text: 'Fotos werden vorbereitet … noch ' + this.laedt }));
    var txt = this.kalender
      ? (this.fotos.length + ' von 13 Fotos (Titelblatt + 12 Monate).' + (this.fotos.length && this.fotos.length < 13 ? ' Fehlende Monate kannst du später füllen.' : ''))
      : (this.fotos.length ? this.fotos.length + ' Fotos · wir machen dir einen Vorschlag auf ' + (this.seiten.length - 1) + ' Seiten – danach kannst du alles frei verschieben.' : 'Wähle so viele Fotos, wie du magst. Wir machen einen Vorschlag, danach legst du jedes Foto dahin, wo du es willst.');
    I.appendChild(el('p', { class: 'lb-zaehler', text: txt }));
    if (this.fotos.length) {
      var r = el('div', { class: 'lb-raster' });
      this.fotos.forEach(function (f, i) {
        var b = el('button', { 'aria-label': 'Foto ' + (i + 1) + ' entfernen', title: 'Antippen zum Entfernen' }, [el('img', { src: f.mini, alt: '' }), el('b', { text: String(i + 1) })]);
        if (f.klein) b.appendChild(el('span', { class: 'klein', text: 'klein' }));
        b.addEventListener('click', function () { if (window.confirm('Dieses Foto entfernen?')) { self.fotoEntfernen(f.id); } });
        r.appendChild(b);
      });
      I.appendChild(r);
      if (this.fotos.some(function (f) { return f.klein; })) I.appendChild(el('p', { class: 'lb-hinweis', text: '„klein“ = wenig Pixel. Diese Fotos lieber kleiner auf die Seite legen.' }));
    }
    I.appendChild(el('span', { class: 'lb-label', text: this.kalender ? 'Größe' : 'Größe & Einband' }));
    I.appendChild(this.formatWahl());
    this.knWeiter.setAttribute('aria-disabled', this.pruefung('fotos') ? 'true' : 'false');
    this.seiteZeigen();
  };
  G.fotoEntfernen = function (id) {
    this.fotos = this.fotos.filter(function (f) { if (f.id === id) URL.revokeObjectURL(f.mini); return f.id !== id; });
    this.seiten.forEach(function (s) { s.slots.forEach(function (x) { if (x.foto === id) x.foto = null; }); });
    if (!this.bearbeitet) this.verteilen();
    this.zeigen();
  };

  /* Werkzeuge für das gewählte Element (Umschlag + Seiten) */
  G.werkzeuge = function (I) {
    var self = this, sel = this.sel, seite = this.aktSeite();
    if (!sel) return false;
    if (sel.art === 'foto') {
      var sl = seite.slots[sel.j]; if (!sl) { this.sel = null; return false; }
      var w = el('div', { class: 'lb-chips lb-werkzeug' });
      function kn(t, fn, an) { var b = el('button', { class: 'lb-chip', type: 'button', text: t, onclick: fn }); if (an != null) b.setAttribute('aria-pressed', String(an)); w.appendChild(b); return b; }
      if (sl.foto) kn('Bildausschnitt', function () { self.ausschnittModus = !self.ausschnittModus; self.inhaltAktuell(); }, this.ausschnittModus);
      kn(sl.foto ? 'Foto tauschen' : 'Foto einsetzen', function () { self.wahlAuf(self.k() === 'umschlag' ? 0 : self.akt, sel.j); });
      kn('Ganze Seite', function () { self.merken(); sl.r = [0, 0, 1, 1]; sl.fx = .5; sl.fy = .5; sl.z = 1; self.inhaltAktuell(); });
      kn('Mit Rand', function () { self.merken(); sl.r = [.08, .08, .84, .84]; self.inhaltAktuell(); });
      if (seite.slots.length > 1) {
        kn('Nach vorne', function () { self.merken(); seite.slots.push(seite.slots.splice(sel.j, 1)[0]); self.sel = { art: 'foto', j: seite.slots.length - 1 }; self.inhaltAktuell(); });
        kn('Nach hinten', function () { self.merken(); seite.slots.unshift(seite.slots.splice(sel.j, 1)[0]); self.sel = { art: 'foto', j: 0 }; self.inhaltAktuell(); });
      }
      kn('Kopieren', function () { self.merken(); var c = kopie(sl); c.r[0] = begr(c.r[0] + .05, -c.r[2] + .05, .95); c.r[1] = begr(c.r[1] + .05, -c.r[3] + .05, .95); seite.slots.push(c); self.sel = { art: 'foto', j: seite.slots.length - 1 }; self.inhaltAktuell(); });
      if (seite.art !== 'umschlag' || seite.slots.length > 1) kn('Löschen', function () { self.auswahlLoeschen(); }).classList.add('weg');
      kn('Fertig', function () { self.auswahl(null); }).classList.add('fertig');
      I.appendChild(w);
      I.appendChild(el('p', { class: 'lb-hinweis', text: this.ausschnittModus ? 'Im Bild ziehen verschiebt den Ausschnitt, zwei Finger (oder Mausrad) zoomen. Nochmal „Bildausschnitt“ = zurück zum Verschieben.' : 'Foto ziehen = verschieben · an den Ecken ziehen = Größe · zwei Finger = größer/kleiner. Unten ein Foto antippen = austauschen.' }));
      return true;
    }
    var t = seite.texte[sel.j]; if (!t) { this.sel = null; return false; }
    var feld = el('textarea', { class: 'lb-feld lb-textfeld', rows: '2', maxlength: t.rolle === 'titel' ? '40' : t.rolle === 'unter' ? '60' : '160', placeholder: t.rolle === 'titel' ? 'Titel' : t.rolle === 'unter' ? 'Untertitel (optional)' : 'z. B. Sommer an der Ostsee', 'aria-label': 'Text' });
    feld.value = this.textInhalt(t);
    var gemerkt = false;
    feld.addEventListener('input', function () {
      if (!gemerkt) { gemerkt = true; self.merken(); }
      if (t.rolle === 'titel') self.titel = feld.value; else if (t.rolle === 'unter') self.unter = feld.value; else t.t = feld.value;
      self.seiteZeigen(); self.knWeiter.setAttribute('aria-disabled', self.pruefung(self.k()) ? 'true' : 'false');
    });
    I.appendChild(feld);
    I.appendChild(el('span', { class: 'lb-label', text: 'Schriftgröße' }));
    var gr = el('input', { type: 'range', class: 'lb-regler', min: '12', max: '160', step: '1', value: String(Math.round(t.g * 1000)), 'aria-label': 'Schriftgröße' });
    var gm = false;
    gr.addEventListener('input', function () { if (!gm) { gm = true; self.merken(); } t.g = +gr.value / 1000; self.seiteZeigen(); });
    I.appendChild(gr);
    var w2 = el('div', { class: 'lb-chips lb-werkzeug', style: 'margin-top:10px' });
    w2.appendChild(el('button', { class: 'lb-chip', type: 'button', text: 'Mittig', onclick: function () { self.merken(); t.x = (1 - t.w) / 2; self.seiteZeigen(); } }));
    if (t.rolle !== 'titel') { var lb = el('button', { class: 'lb-chip weg', type: 'button', text: 'Text löschen', onclick: function () { self.auswahlLoeschen(); } }); w2.appendChild(lb); }
    w2.appendChild(el('button', { class: 'lb-chip fertig', type: 'button', text: 'Fertig', onclick: function () { self.auswahl(null); } }));
    I.appendChild(w2);
    I.appendChild(el('p', { class: 'lb-hinweis', text: 'Text ziehen = verschieben · seitliche Griffe = Breite · zwei Finger = Schriftgröße.' }));
    return true;
  };
  G.fotoLeiste = function (I, titel) {
    var self = this;
    I.appendChild(el('span', { class: 'lb-label', text: titel }));
    var r = this.fotoRaster(function (f) { self.fotoAufSeite(f); }, null);
    r.classList.add('lb-leiste-fotos');
    r.appendChild(el('button', { class: 'lb-mehr-fotos', 'aria-label': 'Weitere Fotos hinzufügen', html: '<span>+</span>', onclick: function () { self.datei.click(); } }));
    I.appendChild(r);
  };

  G.inhaltUmschlag = function () {
    var self = this, I = this.inhalt; I.textContent = ''; this.akt = 0;
    I.appendChild(this.frage(this.kalender ? 'Wie heißt euer Kalender?' : 'Was steht auf dem Umschlag?', 'Pflicht'));
    if (this.werkzeuge(I)) { this.seiteZeigen(); return; }
    var t = el('input', { class: 'lb-feld', maxlength: '40', value: this.titel, 'aria-label': 'Titel', placeholder: 'z. B. Unser Jahr 2026' });
    t.addEventListener('input', function () { self.titel = t.value; self.seiteZeigen(); self.knWeiter.setAttribute('aria-disabled', self.pruefung('umschlag') ? 'true' : 'false'); });
    var u = el('input', { class: 'lb-feld', maxlength: '60', value: this.unter, 'aria-label': 'Untertitel', placeholder: 'Untertitel, z. B. Lena & Tom (optional)' });
    u.addEventListener('input', function () { self.unter = u.value; self.seiteZeigen(); });
    I.append(t, u);
    var ideen = this.kalender ? ['Unser Jahr ' + this.start.jahr, 'Familie ' + this.start.jahr, 'Unsere schönsten Momente'] : ['Unser Jahr', 'Unsere Geschichte', 'Für immer wir', 'Unser Sommer'];
    var ch = el('div', { class: 'lb-chips', style: 'margin-top:10px' });
    ideen.forEach(function (x) { ch.appendChild(el('button', { class: 'lb-chip', type: 'button', text: x, onclick: function () { self.titel = x; t.value = x; self.seiteZeigen(); } })); });
    I.appendChild(ch);
    if (this.kalender) {
      I.appendChild(el('span', { class: 'lb-label', text: 'Der Kalender beginnt mit' }));
      var wahl = el('div', { class: 'lb-chips' });
      [[this.start.jahr, 0], [new Date().getFullYear(), new Date().getMonth() + 1]].forEach(function (v) {
        var j = v[0] + Math.floor(v[1] / 12), m = v[1] % 12;
        wahl.appendChild(el('button', { class: 'lb-chip', type: 'button', 'aria-pressed': String(self.start.jahr === j && self.start.monat === m), text: MONATE[m] + ' ' + j, onclick: function () { self.start = { jahr: j, monat: m }; self.inhaltUmschlag(); } }));
      });
      I.appendChild(wahl);
    }
    I.appendChild(el('p', { class: 'lb-hinweis', text: 'Tipp: Foto und Schrift oben antippen – dann kannst du sie verschieben und an den Ecken größer oder kleiner ziehen.' }));
    this.fotoLeiste(I, this.kalender ? 'Foto für das Titelblatt (antippen)' : 'Foto für den Umschlag (antippen)');
    I.appendChild(el('span', { class: 'lb-label', text: 'Hintergrund' }));
    I.appendChild(this.farbWahl(this.seiten[0]));
    this.seiteZeigen();
  };
  G.fotoRaster = function (wahl, aktiv) {
    var self = this, r = el('div', { class: 'lb-raster' });
    this.fotos.forEach(function (f) {
      var n = self.nutzung(f.id), b = el('button', { 'aria-label': 'Foto wählen' }, [el('img', { src: f.mini, alt: '' })]);
      if (n) b.appendChild(el('b', { text: n + '×' }));
      if (f.id === aktiv) b.classList.add('wahl');
      b.addEventListener('click', function () { wahl(f); });
      r.appendChild(b);
    });
    return r;
  };
  G.farbWahl = function (seite) {
    var self = this, fa = el('div', { class: 'lb-farben klein' });
    var akt = seite ? (seite.grund || this.stil.grund) : this.stil.grund;
    Object.keys(GRUENDE).forEach(function (k) {
      var b = el('button', { class: 'lb-farbe', type: 'button', 'aria-pressed': String(akt === k), 'aria-label': GRUENDE[k].name, title: GRUENDE[k].name });
      b.style.background = GRUENDE[k].grund;
      b.addEventListener('click', function () {
        if (seite) { self.merken(); seite.grund = k; } else { self.stil.grund = k; self.seiten.forEach(function (s) { s.grund = null; }); }
        self.inhaltAktuell(); if (!seite) self.inhaltStil();
      });
      fa.appendChild(b);
    });
    return fa;
  };

  G.inhaltSeiten = function () {
    var self = this, I = this.inhalt; I.textContent = '';
    if (this.akt === 0) this.akt = 1;
    var seite = this.seiten[this.akt];
    I.appendChild(this.frage(this.kalender ? 'Gestalte jeden Monat' : 'Gestalte jede Seite, wie du willst', 'Frei'));
    this.streifen = el('div', { class: 'lb-streifen', role: 'list' });
    I.appendChild(this.streifen); this.streifenAuffrischen();
    var hatWerkzeug = this.werkzeuge(I);
    if (!hatWerkzeug) {
      I.appendChild(el('p', { class: 'lb-hinweis', style: 'margin:2px 0 6px', text: 'Foto oben antippen = verschieben, Ecken = Größe. Unten ein Foto antippen = auf die Seite legen. Wischen blättert.' }));
      var los = el('div', { class: 'lb-chips' });
      los.appendChild(el('button', { class: 'lb-chip', type: 'button', html: '<b>+</b> Text', onclick: function () { self.textDazu(); } }));
      los.appendChild(el('button', { class: 'lb-chip', type: 'button', html: '<b>+</b> Leerer Rahmen', onclick: function () { self.merken(); seite.slots.push(neuSlot([.25, .25, .5, .5])); self.sel = { art: 'foto', j: seite.slots.length - 1 }; self.inhaltSeiten(); } }));
      I.appendChild(los);
    }
    this.fotoLeiste(I, hatWerkzeug ? 'Foto austauschen (antippen)' : 'Deine Fotos (antippen = auf die Seite)');
    if (hatWerkzeug) { this.seiteZeigen(); return; }
    I.appendChild(el('span', { class: 'lb-label', text: 'Schnell-Aufteilung (danach frei verschiebbar)' }));
    var ch = el('div', { class: 'lb-chips' });
    BUCH_LAYOUTS.forEach(function (key) {
      if (self.kalender && key === 'collage') return;
      var b = el('button', { class: 'lb-chip', type: 'button', 'aria-label': LAYOUTS[key].name, title: LAYOUTS[key].name, html: layoutIcon(key) });
      b.addEventListener('click', function () { self.layoutSetzen(seite, key); self.sel = null; self.inhaltSeiten(); });
      ch.appendChild(b);
    });
    I.appendChild(ch);
    I.appendChild(el('span', { class: 'lb-label', text: 'Hintergrund dieser Seite' }));
    I.appendChild(this.farbWahl(seite));
    if (!this.kalender) {
      I.appendChild(el('span', { class: 'lb-label', text: 'Seiten' }));
      var mehr = el('div', { class: 'lb-chips' });
      var schritt = this.format.schritt || 2, innen = this.seiten.length - 1;
      function kn(t, fn, aus) { var b = el('button', { class: 'lb-chip', type: 'button', text: t, onclick: fn }); if (aus) b.disabled = true; mehr.appendChild(b); }
      kn('+ ' + schritt + ' Seiten', function () { self.merken(); for (var i = 0; i < schritt; i++) self.seiten.splice(self.akt + 1 + i, 0, self.leereSeite()); self.akt++; self.inhaltSeiten(); }, innen + schritt > this.format.seitenMax);
      kn('Seite kopieren', function () { self.merken(); self.seiten.splice(self.akt + 1, 0, kopie(seite)); self.seiten.splice(self.akt + 2, 0, self.leereSeite()); self.akt++; self.meldung('Kopie eingefügt (+ eine leere Seite, weil die Seitenzahl gerade sein muss).'); self.inhaltSeiten(); }, innen + schritt > this.format.seitenMax);
      kn('◀ Seite nach vorne', function () { self.merken(); var s = self.seiten.splice(self.akt, 1)[0]; self.seiten.splice(self.akt - 1, 0, s); self.akt--; self.inhaltSeiten(); }, this.akt <= 1);
      kn('Seite nach hinten ▶', function () { self.merken(); var s = self.seiten.splice(self.akt, 1)[0]; self.seiten.splice(self.akt + 1, 0, s); self.akt++; self.inhaltSeiten(); }, this.akt >= this.seiten.length - 1);
      kn('Seite leeren', function () { self.merken(); seite.slots = []; seite.texte = []; self.inhaltSeiten(); });
      kn('− ' + schritt + ' leere Seiten', function () { self.leereEntfernen(schritt); }, innen - schritt < this.format.seitenMin);
      kn('Alles neu vorschlagen', function () { if (window.confirm('Alle Seiten neu automatisch verteilen? Deine Änderungen gehen verloren (Rückgängig ist möglich).')) { self.merken(); self.verteilen(); self.inhaltSeiten(); } });
      I.appendChild(mehr);
    }
    this.seiteZeigen();
  };
  G.layoutSetzen = function (seite, key) {
    this.merken();
    var alt = seite.slots.filter(function (x) { return x.foto; }), n = LAYOUTS[key].slots.length;
    seite.layout = key;
    seite.slots = LAYOUTS[key].slots.map(function (r, j) { return neuSlot(r, alt[j] ? alt[j].foto : null); });
    if (alt.length > n) this.meldung((alt.length - n) + ' Foto(s) passen nicht in diese Aufteilung – sie liegen weiter unten bereit (Rückgängig möglich).');
  };
  G.leereEntfernen = function (anzahl) {
    this.merken();
    var weg = 0;
    for (var i = this.seiten.length - 1; i > 0 && weg < anzahl; i--) {
      if (this.seiten[i].slots.every(function (x) { return !x.foto; }) && !(this.seiten[i].texte || []).some(function (t) { return t.t; })) { this.seiten.splice(i, 1); weg++; }
    }
    var s = this.format.schritt || 2;
    if (weg < anzahl) { this.meldung('Es gibt nicht genug leere Seiten zum Entfernen.'); while ((this.seiten.length - 1) % s) this.seiten.push(this.leereSeite()); }
    this.akt = Math.max(1, Math.min(this.akt, this.seiten.length - 1)); this.inhaltSeiten();
  };
  G.streifenAuffrischen = function () {
    var self = this, st = this.streifen; if (!st || !st.isConnected) return;
    st.textContent = ''; var mm = this.seiteMm();
    this.seiten.forEach(function (s, i) {
      if (i === 0) return;
      var mini = el('span', { class: 'mini' }); mini.style.setProperty('--ar', mm.b / mm.h); mini.style.background = self.grundVon(s).grund;
      s.slots.forEach(function (x) {
        var f = x.foto && self.foto(x.foto); if (!f) return;
        var im = el('img', { src: f.mini, alt: '' });
        im.style.left = x.r[0] * 100 + '%'; im.style.top = x.r[1] * 100 + '%'; im.style.width = x.r[2] * 100 + '%'; im.style.height = x.r[3] * 100 + '%';
        mini.appendChild(im);
      });
      var b = el('button', { role: 'listitem', 'aria-current': String(i === self.akt), 'aria-label': self.kalender ? MONATE[(self.start.monat + i - 1) % 12] : 'Seite ' + i }, [mini, self.kalender ? MONATE[(self.start.monat + i - 1) % 12].slice(0, 3) : String(i)]);
      b.addEventListener('click', function () { self.gehe(i); });
      st.appendChild(b);
    });
    var aktEl = st.querySelector('[aria-current="true"]'); if (aktEl) aktEl.scrollIntoView({ block: 'nearest', inline: 'center' });
  };

  G.wahlAuf = function (idx, j) {
    var self = this;
    this.wahlDlg = el('div', { class: 'lb-wahl', role: 'dialog', 'aria-label': 'Foto wählen', onclick: function (e) { if (e.target === self.wahlDlg) self.wahlZu(); } });
    var box = el('div');
    box.append(el('button', { class: 'zu', text: 'Schließen', onclick: function () { self.wahlZu(); } }), el('h3', { text: 'Welches Foto?' }));
    box.appendChild(el('button', { class: 'lb-hoch', html: ICON.foto + '<span>Neue Fotos hinzufügen</span>', onclick: function () { self.wahlZu(); self.datei.click(); } }));
    var sl = this.seiten[idx].slots[j];
    box.appendChild(this.fotoRaster(function (f) { self.merken(); sl.foto = f.id; sl.fx = .5; sl.fy = .5; sl.z = 1; self.sel = { art: 'foto', j: j }; self.wahlZu(); self.inhaltAktuell(); }, sl && sl.foto));
    this.wahlDlg.appendChild(box); this.wurzel.appendChild(this.wahlDlg);
  };
  G.wahlZu = function () { if (this.wahlDlg) { this.wahlDlg.remove(); this.wahlDlg = null; } };

  G.inhaltStil = function () {
    var self = this, I = this.inhalt; I.textContent = '';
    I.appendChild(this.frage('Welcher Stil gefällt dir?', 'Optional'));
    I.appendChild(el('span', { class: 'lb-label', text: 'Seitenfarbe für alle Seiten' }));
    I.appendChild(this.farbWahl(null));
    I.appendChild(el('p', { class: 'lb-hinweis', text: GRUENDE[this.stil.grund].name + ' · setzt eigene Seitenfarben zurück' }));
    I.appendChild(el('span', { class: 'lb-label', text: 'Schrift' }));
    var ch = el('div', { class: 'lb-chips' });
    Object.keys(SCHRIFTEN).forEach(function (k) {
      var b = el('button', { class: 'lb-chip', type: 'button', 'aria-pressed': String(self.stil.schrift === k), text: SCHRIFTEN[k].name });
      b.style.fontFamily = SCHRIFTEN[k].css; b.addEventListener('click', function () { self.stil.schrift = k; self.inhaltStil(); });
      ch.appendChild(b);
    });
    I.appendChild(ch);
    if (this.akt === 0) this.akt = 1;
    this.seiteZeigen();
  };

  G.luecken = function () {
    var leer = 0, klein = 0, self = this, mm = this.seiteMm();
    this.seiten.forEach(function (s) {
      s.slots.forEach(function (x) {
        if (!x.foto) { leer++; return; }
        var f = self.foto(x.foto), r = x.r; if (!f) return;
        var sichtB = Math.min(1, r[0] + r[2]) - Math.max(0, r[0]); if (sichtB <= 0) return;
        var a = ausschnitt(r[2] * mm.b, r[3] * mm.h, f.b, f.h, x.fx, x.fy, x.z);
        var dpi = (Math.min(f.b, 4200) / a.W) / (r[2] * mm.b / 25.4); // Pixel über die Platzbreite
        if (dpi < 150) klein++;
      });
    });
    return { leer: leer, klein: klein };
  };
  G.inhaltPruefen = function () {
    var self = this, I = this.inhalt; I.textContent = '';
    I.appendChild(this.frage(this.kalender ? 'Bitte prüf deinen Kalender' : 'Bitte prüf dein Fotobuch'));
    I.appendChild(el('p', { class: 'lb-hinweis', style: 'margin:-6px 0 8px', text: 'So wird es gedruckt. Blättere oben durch alle Seiten.' }));
    var l = el('ul', { class: 'lb-pruef' });
    function zeile(a, b, schritt) { l.appendChild(el('li', {}, [el('span', { text: a }), el('b', { text: b }), el('button', { type: 'button', text: 'Ändern', onclick: function () { self.zuSchritt(schritt); } })])); }
    zeile('Format', this.format.label, 0);
    zeile('Titel', this.titel + (this.unter ? ' · ' + this.unter : ''), 1);
    if (this.kalender) zeile('Beginnt', MONATE[this.start.monat] + ' ' + this.start.jahr, 1); else zeile('Seiten', (this.seiten.length - 1) + ' Innenseiten', 2);
    zeile('Fotos', this.fotos.length + ' Fotos', 0);
    zeile('Stil', GRUENDE[this.stil.grund].name + ' · ' + SCHRIFTEN[this.stil.schrift].name, 3);
    I.appendChild(l);
    var lk = this.luecken();
    if (lk.leer) I.appendChild(el('div', { class: 'lb-warn', text: lk.leer + (lk.leer === 1 ? ' Rahmen ist' : ' Rahmen sind') + ' noch ohne Foto und ' + (lk.leer === 1 ? 'wird' : 'werden') + ' nicht gedruckt (bleibt Seitenfarbe).' }));
    if (lk.klein) I.appendChild(el('div', { class: 'lb-warn', text: lk.klein + (lk.klein === 1 ? ' Foto ist' : ' Fotos sind') + ' für die Größe eher klein und kann leicht unscharf wirken. Tipp: etwas kleiner ziehen.' }));
    var cb = el('input', { type: 'checkbox', id: 'lb-ok' }); cb.checked = this.geprueft;
    cb.addEventListener('change', function () { self.geprueft = cb.checked; self.knWeiter.setAttribute('aria-disabled', self.pruefung('pruefen') ? 'true' : 'false'); });
    I.appendChild(el('label', { class: 'lb-ok', for: 'lb-ok' }, [cb, el('span', { text: 'Ich habe alle Seiten geprüft. Das ' + (this.kalender ? 'Kalender' : 'Fotobuch') + ' wird nur für mich gefertigt und ist deshalb vom Widerruf ausgeschlossen.' })]));
    this.knWeiter.setAttribute('aria-disabled', this.pruefung('pruefen') ? 'true' : 'false');
    this.nav.hidden = false;
    this.seiteZeigen();
  };

  /* ---------- Projekt für Druck & Warenkorb ---------- */
  G.projekt = function () {
    var self = this, r4 = function (v) { return +v.toFixed(4); };
    return {
      version: 2, art: this.K.art, format: this.format.key, mm: this.seiteMm(), titel: this.titel, unter: this.unter,
      start: this.kalender ? this.start : null, stil: this.stil,
      fotos: this.fotos.map(function (f) { return { id: f.id, b: f.b, h: f.h, name: f.name }; }),
      seiten: this.seiten.map(function (s) {
        return {
          art: s.art, layout: s.layout || null, grund: s.grund || null,
          slots: s.slots.filter(function (x) { return x.foto; }).map(function (x) { return { foto: x.foto, r: x.r.map(r4), fx: r4(x.fx), fy: r4(x.fy), z: +x.z.toFixed(3) }; }),
          texte: (s.texte || []).map(function (t) { return { rolle: t.rolle || null, t: self.textInhalt(t) || '', x: r4(t.x), y: r4(t.y), w: r4(t.w), g: r4(t.g) }; }).filter(function (t) { return t.t; })
        };
      })
    };
  };
  G.abgeben = function () {
    var self = this, p = this.projekt();
    var benutzt = {}; p.seiten.forEach(function (s) { s.slots.forEach(function (x) { if (x.foto) benutzt[x.foto] = 1; }); });
    var dateien = this.fotos.filter(function (f) { return benutzt[f.id]; }).map(function (f) { return { id: f.id, blob: f.druck }; });
    this.knWeiter.setAttribute('aria-disabled', 'true'); this.knWeiter.textContent = 'Wird hochgeladen …';
    var abgabe = (this.K.abgabe || window.LRBuchAbgabe);
    if (!abgabe) { console.log('LRBuch Projekt', p, dateien); window.LRBuchLetztesProjekt = p; this.meldung('Testmodus: Projekt in der Konsole.'); this.zeigen(); return; }
    abgabe(p, dateien, this.format, function (stand) { self.knWeiter.textContent = stand; }).then(function () {
      self.abgegeben = true; window.removeEventListener('beforeunload', self.vorAbschied);
    }, function (e) { self.meldung('Hochladen hat nicht geklappt. Bitte noch einmal versuchen.'); console.warn(e); self.zeigen(); });
  };

  window.addEventListener('resize', function () { if (window.LRBuch && LRBuch.aktiv && LRBuch.aktiv.wurzel.isConnected) LRBuch.aktiv.seiteZeigen(); });
  window.LRBuch = {
    oeffnen: function (k) { this.aktiv = new Gestalter(k); return this.aktiv; },
    ausschnitt: ausschnitt, LAYOUTS: LAYOUTS, UMSCHLAG: UMSCHLAG, KAL_TITEL: KAL_TITEL, KAL_MONAT: KAL_MONAT, GRUENDE: GRUENDE
  };
})();
